import './controls/additional-charges';
import './controls/ajax';
import './controls/ajax-tab';
import './controls/alert';
import './controls/autocomplete';
import './controls/autolist';
import './controls/autolist-input';
import './controls/bootstrap-multiselect';
import './controls/box-select';
import './controls/button-div-select';
import './controls/cc-number';
import './controls/checkbox-list-select';
import './controls/checkboxes-table';
import './controls/checkboxes-values';
import './controls/checkin-user-picker';
import './controls/color-picker';
import './controls/confirm';
import './controls/create-new-client';
import './controls/dashboard';
import './controls/date-picker';
import './controls/date-picker-proui';
import './controls/date-range-picker';
import './controls/date-selector';
import './controls/dialog';
import './controls/dialog-form';
import './controls/dropdown';
import './controls/error';
import './controls/file-upload';
import './controls/file-upload-simple';
import './controls/kiosk-preview';
import './controls/gender-toggle';
import './controls/grid-scroll';
import './controls/loading-splash';
import './controls/membership-select';
import './controls/mini-cart';
import './controls/multi-autocomplete';
import './controls/multi-selection-list';
import './controls/multi-select-one-line';
import './controls/password';
import './controls/phone';
import './controls/phones-group';
import './controls/play-sound';
import './controls/print';
import './controls/radio-with-text';
import './controls/schedule-grid';
import './controls/schedule-grid-block';
import './controls/select';
import './controls/select-pro';
import './controls/select-with-input';
import './controls/selection-list';
import './controls/session-expire-window';
import './controls/switcher';
import './controls/tab';
import './controls/tags-input';
import './controls/text';
import './controls/textarea';
import './controls/time-range';
import './controls/user-picker';
import './layout/change-user-role-form';

import '../styles/controls/controls.css';
import '../styles/controls/animations.css';
import '../styles/controls/bootstrap-colorpicker.css';
import '../styles/controls/bootstrap-datepicker2.css';
import '../styles/controls/bootstrap-selectize.css';
import '../styles/controls/bootstrap-slider.css';
import '../styles/controls/bootstrap-timepicker.css';
import '../styles/controls/bootstrap-wysihtml5.css';
import '../styles/controls/buttons.css';
import '../styles/controls/datatables.css';
import '../styles/controls/datepicker.css';
import '../styles/controls/easy-pie-chart.css';
import '../styles/controls/gradients.css';
import '../styles/controls/magnific-popup.css';
import '../styles/controls/select2.css';
